import { DefaultError } from 'src/app/shared/constants/errors.constants';

export const getErrorKey = (errorResponse, defaultErrorKey = DefaultError): string => {
  // errorCode should be localization LocalizationItemParams.ContentId to apply localization
  const errorKeyFromBE = errorResponse?.error?.code;

  return errorKeyFromBE || defaultErrorKey;
};
